import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, History } from "lucide-react";
import { api } from "@/lib/api";
import { ActivityItem } from "@/components/ActivityItem";

const FILTERS = [["", "Everything"], ["show", "Shows"], ["episode", "Episodes"], ["host", "Hosts"], ["submission", "Submissions"], ["site", "Website"], ["sync", "Feed syncs"], ["inbox", "Inbox"]];

export default function ActivityAdmin() {
  const [items, setItems] = useState(null);
  const [kind, setKind] = useState("");
  useEffect(() => { api.get("/admin/activity", { params: { limit: 500, days: 7 } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const shown = (items || []).filter((i) => !kind || i.kind === kind);
  const groups = shown.reduce((acc, i) => { const d = new Date(i.created_at).toLocaleDateString([], { weekday: "long", month: "short", day: "numeric" }); (acc[d] ||= []).push(i); return acc; }, {});
  return (
    <div data-testid="activity-admin">
      <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white" data-testid="activity-back"><ArrowLeft size={14} /> Dashboard</Link>
      <div className="mt-3 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow mb-1 flex items-center gap-1.5"><History size={12} /> Activity</p>
          <h1 className="font-display text-3xl font-extrabold">Updates from the past 7 days</h1>
          <p className="text-sm text-slate-400 mt-1">Every change to shows, episodes, hosts, submissions and the website — by you, your hosts, or the feed sync.</p>
        </div>
        <div className="inline-flex flex-wrap gap-1 rounded-full bg-white/5 p-1" data-testid="activity-filters">
          {FILTERS.map(([k, label]) => <button key={k} type="button" onClick={() => setKind(k)} className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${kind === k ? "bg-sky-400 text-[#070F1E]" : "text-slate-300 hover:text-white"}`} data-testid={`activity-filter-${k || "all"}`}>{label}</button>)}
        </div>
      </div>
      <div className="mt-6 space-y-6">
        {items === null && <p className="text-sm text-slate-400">Loading…</p>}
        {items !== null && shown.length === 0 && <p className="text-sm text-slate-400 card-surface rounded-2xl p-6" data-testid="activity-empty">No updates in the past week{kind ? " for this filter" : ""}.</p>}
        {Object.entries(groups).map(([day, list]) => (
          <section key={day} className="card-surface rounded-2xl p-4" data-testid="activity-day">
            <p className="eyebrow mb-2 px-3">{day} <span className="text-slate-500 normal-case tracking-normal font-sans">· {list.length}</span></p>
            <ul className="space-y-0.5">{list.map((item, i) => <ActivityItem key={item.id} item={item} index={i} showDate />)}</ul>
          </section>
        ))}
      </div>
    </div>
  );
}
